// Remove cart dropdown if layout is cart flow
if (document.querySelectorAll(".s-cart-steps").length) {
  document.querySelector(".i-cart-dropdown")?.remove()
}
